"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectListConverter_1 = require("../../core/conversions/DataObjectListConverter");
/**
 * @author PKr
 */


var ForecastSimulationTreeDataDTOConverter =
/*#__PURE__*/
function (_DataObjectListConver) {
  _inherits(ForecastSimulationTreeDataDTOConverter, _DataObjectListConver);

  function ForecastSimulationTreeDataDTOConverter() {
    _classCallCheck(this, ForecastSimulationTreeDataDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ForecastSimulationTreeDataDTOConverter).apply(this, arguments));
  }

  return ForecastSimulationTreeDataDTOConverter;
}(DataObjectListConverter_1.DataObjectListConverter);

exports.ForecastSimulationTreeDataDTOConverter = ForecastSimulationTreeDataDTOConverter;